import CustomerProfileAdvancedView from './CustomerProfileAdvancedView'

export default CustomerProfileAdvancedView
